/**
 * @generated SignedSource<<90ffa3423eb75db18090926f8dde78ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ENSAvatarFragment$data = {
  readonly name: string | null;
  readonly " $fragmentType": "ENSAvatarFragment";
};
export type ENSAvatarFragment$key = {
  readonly " $data"?: ENSAvatarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ENSAvatarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ENSAvatarFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "ResolvedName",
  "abstractKey": null
};

(node as any).hash = "855b1a16c54d89de4bbde61a88e3218b";

export default node;
